import React, { useEffect, useState } from 'react';
import AliceCarousel from 'react-alice-carousel';
import SEO from '../../../components/Seo';
import { Layout, Section } from '../../../components/layout';
import Image from '../../../components/Image';


export default function CertegoAntifragileReviewPage(props) {
    const [pageLoaded, setPageLoaded] = useState(false);

    useEffect(() => setPageLoaded(true), []); // to use window with SSR

    return (
        <Layout pageProps={props}>
            <Section
                head
                white
                className="h-[220px] sm:h-[280px] md:h-[400px] lg:h-[500px] xl:h-[600px] 2xl:h-[760px] 3xl:h-[780px] !bg-certego-gray"
                background={
                    <Image img="resources/events-and-webinars/certego-antifragile/title.webp" alt="evento antifragilità" className="max-h-[780px] w-full object-fill" />
                }
            >
                <div className="mt-[50px] lg:mt-[150px]">
                    <h1 className="!text-certego-white md:font-bold">PanoptiCON 2024</h1>
                    <h1 className="!text-certego-blue font-bold uppercase md:text-6xl lg:text-8xl">Antifragile</h1>
                    <h2 className="uppercase !text-certego-white max-md:hidden">Come caos e complessità rendono migliori<br />le nostre difese digitali</h2>
                </div>
            </Section>
            <Section>
                <div>
                    <h2 className="text-center">Tutto su PanoptiCON 2024: i video, le interviste, le sessioni tecnologiche, i partner e le foto dell’evento!</h2>
                </div>
            </Section>
            <Section>
                <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-6 text-start text-certego-black">
                    <div>
                        <iframe className="w-full aspect-video" src="https://www.youtube.com/embed/zgzQGgSIOE0" title="YouTube video player" allow="accelerometer; gyroscope; picture-in-picture;" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                    </div>
                    <div>
                        <h2 className="font-bold !text-certego-blue">PanoptiCON 2024</h2>
                        <h3 className="!text-certego-blue">Il video racconto</h3>
                        <p>Quest’anno abbiamo deciso di organizzare il Cybersecurity Event di Certego al Labirinto della Masone, il labirinto più grande del mondo e all’interno della proprietà di Franco Maria Ricci, noto editore e collezionista d’arte.</p>
                        <p>Con Certego PanoptiCon2024 abbiamo voluto creare una riflessione sul parallelismo applicabile al principio di antifragilità in natura e in azienda. Dal Labirinto, emblema universale della ricerca, immersi in una foresta di canne di bambù, siamo partiti dalle virtù di questa prodigiosa pianta che sferzata dal vento e della pioggia, si piega ma non si spezza: si modifica, cambia e torna più forte di prima, proprio come devono essere le nostre difese digitali in risposta agli attacchi informatici.</p>
                    </div>
                </div>
            </Section>
            <Section color="lightgray">
                {pageLoaded && (
                <AliceCarousel
                    mouseTracking
                    items={[...Array(18).keys()].map((i) => <Image key={i} className="px-12" img={`resources/events-and-webinars/certego-antifragile/photos/${i + 1}.webp`} />)}
                    responsive={{
                        0: { items: 1 },
                        568: {
                            items: 2, itemsFit: 'contain',
                        },
                        1024: {
                            items: 3, itemsFit: 'contain',
                        },
                    }}
                    innerWidth={(typeof window !== 'undefined') ? undefined : 1024}
                />
                )}
            </Section>
            <Section>
                <h1 className="!text-certego-blue mb-12 text-center">Gli speech</h1>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {[{
                        title: 'Antifragile: come caos e complessità rendono migliori le nostre difese digitali',
                        author: 'Bernardino Grignaffini Gregorio',
                        link: 'https://www.youtube.com/embed/0ZV3TGKcDeQ',
                    }, {
                        title: 'Il principio di antifragilità in natura',
                        author: 'Prof. Alessandro Chiarucci',
                        link: 'https://www.youtube.com/embed/M0Z6P98ymNc',
                    }, {
                        title: 'Cambiare per sopravvivere: storia di una risposta ad un attacco',
                        author: 'Stefano Fratepietro',
                        link: 'https://www.youtube.com/embed/aaIF9xgAxU4',
                    }].map(({ title, author, link }) => (
                        <article key={title} className="flex flex-col">
                            <div className="mb-4">
                                <iframe className="w-full aspect-video" src={link} title="YouTube video player" allow="accelerometer; gyroscope; picture-in-picture;" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                            </div>
                            <h6 className="!text-certego-blue flex-grow justify-self-center">{title}</h6>
                            <p>{author}</p>
                        </article>
                    ))}
                </div>
            </Section>
            <Section>
                <h1 className="!text-certego-blue text-center">I partner di PanoptiCON 2024</h1>
                <div className="flex flex-wrap items-center gap-12 justify-center mt-12">
                    {[{
                        image: 'rubrik.webp',
                        link: 'https://www.rubrik.com/it',
                    }, {
                        image: 'trendmicro.webp',
                        link: 'https://www.trendmicro.com/it_it/forHome.html',
                    }, {
                        image: 'seedata.webp',
                        link: 'https://www.seedata.io/',
                    }, {
                        image: 'bbs.webp',
                        link: 'https://www.bbs.unibo.it/',
                    }].map(({ image, link }) => (
                        <a key={image} href={link} target="_blank" rel="noreferrer">
                            <Image
                                img={`resources/events-and-webinars/certego-antifragile/partners/${image}`}
                                className="h-[72px]"
                            />
                        </a>
                    ))}
                </div>
            </Section>
            <Section>
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {[{
                        title: 'Intervista ad Alex Galimi',
                        author: 'Technical Partner Manager Trend Micro',
                        link: 'https://www.youtube.com/embed/czutWzeZ8ZM',
                    }, {
                        title: 'Intervista a Fabio Zambon',
                        author: 'Account Executive Rubrik',
                        link: 'https://www.youtube.com/embed/7-rjCkL3l2E',
                    }, {
                        title: 'Intervista a Enrico Faccioli',
                        author: 'CEO & Co-founder at Seedata.io',
                        link: 'https://www.youtube.com/embed/45FpqFPvpnE',
                    }, {
                        title: 'Intervista a Eleonora Leporatti',
                        author: 'Head of Open Programs BBS',
                        link: 'https://www.youtube.com/embed/EDuallibWak',
                    }].map(({ title, author, link }) => (
                        <article key={title} className="flex flex-col">
                            <div className="mb-4">
                                <iframe className="w-full aspect-video" src={link} title="YouTube video player" allow="accelerometer; gyroscope; picture-in-picture;" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />
                            </div>
                            <h6 className="!text-certego-blue flex-grow justify-self-center">{title}</h6>
                            <p>{author}</p>
                        </article>
                    ))}
                </div>
            </Section>
        </Layout>
    );
}

export function Head(props) {
    return (
        <SEO
            title="Evento Certego Antifragile - Come caos e complessità rendono migliori le nostre difese digitali"
            description="Evento Certego Antifragile - Come caos e complessità rendono migliori le nostre difese digitali"
            allProps={props}
        />
    );
}
